<footer>
  <div class="flex">
    <div class="cr">
      <div class="content-font-color">{{ "FOOTER.COPYRIGHT" | translate : { year: year } }}</div>
    </div>
    <ul>
      <li>
        <a
          target="_blank"
          [href]="'FOOTER.PRIVACY-LINK' | translate"
        >
          {{ "FOOTER.PRIVACY" | translate }}
          <span class="rbc-sr-only">, {{ "FOOTER.ALT-TEXT" | translate }}</span>
          <rbc-icon name="external-link" size="sm"></rbc-icon>
        </a>
      </li>
      <li>
        <a target="_blank" [href]="'FOOTER.LEGAL-LINK' | translate">
          {{ "FOOTER.LEGAL" | translate }}
          <span class="rbc-sr-only">, {{ "FOOTER.ALT-TEXT" | translate }}</span>
          <rbc-icon name="external-link" size="sm"></rbc-icon>
        </a>
      </li>
      <li>
        <a
          target="_blank"
          [href]="'FOOTER.ACCESSIBILITY-LINK' | translate"
        >
          {{ "FOOTER.ACCESSIBILITY" | translate }}
          <span class="rbc-sr-only">, {{ "FOOTER.ALT-TEXT" | translate }}</span>
          <rbc-icon name="external-link" size="sm"></rbc-icon>
        </a>
      </li>
    </ul>
  </div>
</footer>
